var _circle, _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_47_1",
    "data-name": "Component 47 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#1aba27",
    opacity: 0.104
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 67.5,
    cy: 68.5,
    rx: 67.5,
    ry: 68.5,
    transform: "translate(15 13)",
    fill: "#1aba27",
    opacity: 0.249
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 53.5,
    cy: 54.5,
    rx: 53.5,
    ry: 54.5,
    transform: "translate(29 27)",
    fill: "#1aba27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.779,29.609a3.1,3.1,0,0,1-2.189-.909L.9,17.009a3.1,3.1,0,0,1,4.379-4.379l9.5,9.5L36.012.9a3.1,3.1,0,0,1,4.379,4.379L16.968,28.7A3.1,3.1,0,0,1,14.779,29.609Z",
    transform: "translate(61.737 66.74)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreenTick);
export default __webpack_public_path__ + "static/media/circle-green-tick.e903798bc241b03404f74472d7e263e8.svg";
export { ForwardRef as ReactComponent };